var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SMSList',{attrs:{"client_name":"DY","table_class":"doomYogaTable","overlay_variant":"doom-yoga-primary","select_filter_class":"v-select-doomyoga","view_img_path":"doom-yoga/view-icon-table.png","currency":"€"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344b567a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/doom_yoga/admin/marketing/SMS.vue
// module id = null
// module chunks = 